/**
 * Maps legacy SDG element/level names (stored in existing DB records) to their
 * current display names. Apply this to any show_element or level value read
 * from the database before comparing against current Constants values.
 */
const SDG_LEGACY_NAMES: Record<string, string> = {
  "Double 0 7": "Super 7",
};

/** Legacy level strings that must still pass schema enum validation. */
export const SDG_LEGACY_LEVEL_VALUES: string[] = Object.keys(SDG_LEGACY_NAMES);

export function normalizeSDGElement(name: string): string {
  return SDG_LEGACY_NAMES[name] ?? name;
}
